import React, {PureComponent} from 'react';
import {Helmet} from 'react-helmet';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';

import ForgottenPasswordModal from '../../components/Modals/ForgottenPassword/ForgottenPasswordModal.jsx';
import LoginForm from '../../components/Forms/LoginForm/LoginForm.jsx';
import LoginLayout from '../Layout/LoginLayout.jsx';
// import SocialAuthentication from '../../components/SocialAuthentication/SocialAuthentication.jsx';
import SubmitButton from '../../components/Forms/LoginForm/SubmitButton.jsx';

import connectModal from '../../../shared/components/Modals/connect.js';
import {generate} from '../../routes.js';
import redirectPostLogin from '../../services/redirectPostLogin.js';

class Login extends PureComponent {
  redirectPostLogin = (result) => {
    redirectPostLogin(result.data.user, this.props.universes, this.props.location?.state?.redirectTo ?? null);
  };

  openForgottenPasswordModal = (e) => {
    e.preventDefault();
    this.props.openForgottenPasswordModal();
  };

  render() {
    const title = 'Connectez-vous à Twineeds';
    const description = 'Accédez à notre plateforme pour effectuer vos recherches de mandats ou de profils, '
      + 'modifier des informations, publier une annonce, etc.';

    const helmet = <Helmet>
      <title>{title}</title>
      <meta name="description" content={description}/>
      <meta property="og:description" content={description}/>
      <meta property="og:title" content={title}/>
    </Helmet>;

    return <LoginLayout helmet={helmet} title="Nous sommes ravis de vous revoir !">
      <LoginForm onSubmitSuccess={this.redirectPostLogin}/>
      <p className="text-right mb-4">
        <a href="#0" onClick={this.openForgottenPasswordModal}>Mot de passe oublié</a>
      </p>
      <SubmitButton className="btn btn-primary w-100">Se connecter</SubmitButton>
      {/*<div className="separator-x bg-gray-200 my-4"/>*/}
      {/*<SocialAuthentication redirect={this.redirectPostLogin}/>*/}
      <p className="text-center mt-4 mb-0">
        Je n'ai pas de compte, m'inscrire comme <Link to={generate({name: 'register-do'})}>entreprise</Link> ou
        comme <Link to={generate({name: 'register-freelance'})}>consultant</Link>
      </p>
    </LoginLayout>;
  }
}

export default connect(
  (state) => ({
    universes: state.universe.universes
  })
)(
  connectModal(
    {ForgottenPasswordModal},
    withRouter(Login)
  )
);
